/**
 * Map of all Cities in the game
 * Key = City Name, Value = City object
 */
import { City } from "./City";
import { IMap } from "../types";

export const Cities: IMap<City> = {};
